module.exports = "https://trybtryb-legacy.web.app/img/pink-sky.e15c221d.webp";